import {Injectable} from '@angular/core';
import {Actions, Effect, ofType} from '@ngrx/effects';
import {Action} from '@ngrx/store';

import {EMPTY, Observable, of} from 'rxjs';

import {Group} from '../../../shared';
import {GroupService} from '../../services/group.service';
import {
  CREATE_GROUP,
  CREATE_SUCCESS,
  CreateFailAction,
  CreateGroupAction,
  CreateSuccessAction,
  REQUEST_GROUP_LIST,
  RequestFailAction,
  RequestGroupListAction,
  RequestSuccessAction
} from '../actions/group.action';
import {catchError, map, switchMap} from 'rxjs/internal/operators';

@Injectable()
export class GroupEffects {
  @Effect()
  request$: Observable<Action> = this.actions$.pipe(
    ofType(REQUEST_GROUP_LIST),
    map((action: RequestGroupListAction) => action.payload),
    switchMap((orgToken: string) => {
      if (orgToken === '') {
        return EMPTY;
      }

      return this.groupService.requestMyGroupList(orgToken);
    }),
    map((groupList: Group[]) => new RequestSuccessAction(groupList)),
    catchError(() => of(new RequestFailAction()))
  );

  @Effect()
  create$: Observable<Action> = this.actions$.pipe(
    ofType(CREATE_GROUP),
    map((action: CreateGroupAction) => action.payload),
    switchMap((payload: { orgToken: string, name: string }) => {
      if (payload.orgToken === '' || payload.name === '') {
        return EMPTY;
      }

      return this.groupService.createGroup(payload.orgToken, payload.name).pipe(
        map((response: { message: string }) => new CreateSuccessAction(payload.orgToken))
      );
    }),
    catchError(() => of(new CreateFailAction()))
  );

  @Effect()
  createSuccess$: Observable<Action> = this.actions$.pipe(
    ofType(CREATE_SUCCESS),
    map((action: CreateSuccessAction) => action.payload),
    switchMap((orgToken: string) => of(new RequestGroupListAction(orgToken)))
  );

  constructor(private actions$: Actions, private groupService: GroupService) {
  }
}
